import React from 'react'
import styled from 'styled-components'
import Ads from './Ads'
import DaySchedule from './DaySchedule'

class SideBar extends React.Component {
    render() {
        const { schedule } = this.props;

        return(
            <Container>
                { schedule ? <DaySchedule schedule={schedule} /> : null }
             <Ads/>
            </Container>
        )
    }
}


const Container = styled.aside`
  border-left: 1px solid #EDEDED;
  @media (max-width: 800px) {
    border-left: none;
  }
`;


export default SideBar;